type StoreConfig = {
  shopify: {
    handle: string
    url: string
    region: string
  }
  searchspring: {
    collections: string
    products: string
    pages: string
  }
  validation?: {
    phone: {
      prefix: string
      pattern: string
    }
  }
}

function defineStoreConfig(config: StoreConfig) {
  return config
}

const SEARCHSPRING_ID = "gqj2zz"

export const config = {
  stores: {
    "viktoria-woods": defineStoreConfig({
      shopify: {
        handle: "viktoria-woods",
        url: "https://viktoria-woods.myshopify.com",
        region: "AU",
      },
      searchspring: {
        collections: SEARCHSPRING_ID,
        products: SEARCHSPRING_ID,
        pages: SEARCHSPRING_ID,
      },
    }),
  },
} as const

type StoreHandle = keyof typeof config.stores

export function getStoreConfig(handle: StoreHandle) {
  return config.stores[handle]
}

export function getCurrentStoreConfig() {
  const handle = window.SHOPIFY_DATA.shop.handle as StoreHandle
  return getStoreConfig(handle)
}
